import { useMemo } from 'react';
import { LANDING_FEATURE_COUNT } from '../lib/landingFeatures';
import { useCachedPublishedArticles } from './useCachedPublishedArticles';

export function usePublishedFeatureArticles() {
  const { data, loading, error } = useCachedPublishedArticles(
    `/api/articles?type=feature&limit=${LANDING_FEATURE_COUNT}`,
  );

  const articles = useMemo(() => data ?? [], [data]);

  return { articles, loading: loading && articles.length === 0, error };
}
